export default __webpack_public_path__ + "static/media/redOC.9906394b.png";